'use client';
declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element | null, forceReload: boolean) => void;
    };
  }
}

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

interface TrustpilotWidgetProps {
  isFooter?: boolean;
  height?: string;
  containerClassName?: string;
  widgetClassName?: string; // Add optional className prop
}

export const TrustpilotWidget = ({
  isFooter = false,
  height = '160px',
  containerClassName = 'flex justify-center',
  widgetClassName = '',
}: TrustpilotWidgetProps) => {
  const pathname = usePathname(); // Detect route changes

  useEffect(() => {
    setTimeout(() => {
      const widgetElement = document.querySelector(
        isFooter ? 'footer .trustpilot-widget' : '.trustpilot-widget',
      );
      if (widgetElement && typeof window !== 'undefined' && window.Trustpilot) {
        window.Trustpilot.loadFromElement(widgetElement, true);
      }
    }, 500); // Delay to ensure element is in the DOM
  }, [pathname, isFooter]);

  return (
    <div key={pathname} className={`${containerClassName}`}>
      <div
        className={`trustpilot-widget ${widgetClassName}`}
        data-locale="it-IT"
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id="62a700c259087f602917a6ea"
        data-style-height={height}
        data-style-width="100%"
        data-theme="dark"
      >
        <a href="https://it.trustpilot.com/review/vibly.tv" target="_blank" rel="noreferrer">
          Trustpilot
        </a>
      </div>
    </div>
  );
};
